import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import React, { Component } from 'react'
import UploadFile from '../containers/UploadFile'
import * as actions from '../store/actions'
import { connect } from 'react-redux'

class ConfirmationDialog extends Component {
  render() {
    const {
      loadXML,
      isError,
      onUpload,
      onContinue,
      onCloseErrorDialog,
      onClose,
    } = this.props
    return (
      <Dialog open={isError}>
        <DialogTitle>Zmiana edytowanego e-Sprawozdania</DialogTitle>
        <DialogContent>
          {loadXML ? (
            <DialogContentText>
              Zamierzasz otworzyć do edycji inny plik z e-Sprawozdaniem.
              <br />
              Oznacza to, że wszystkie niezapisane informacje w aktualnie
              <br />
              edytowanym e-Sprawozdaniu zostaną utracone.
            </DialogContentText>
          ) : (
            <DialogContentText>
              Zamierzasz utworzyć nowe e-Sprawozdanie.
              <br />
              Oznacza to, że wszystkie niezapisane informacje w aktualnie
              <br />
              edytowanym e-Sprawozdaniu zostaną utracone.
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          {loadXML ? (
            <UploadFile
              label="OTWÓRZ PLIK"
              filter=".xml,.zip,.lzh"
              onUpload={onUpload}
              onCloseErrorDialog={onCloseErrorDialog}
              variant="text"
              isErrorDialog
            />
          ) : (
            <Button
              onClick={() => {
                onContinue()
              }}
              color="primary"
            >
              UTWÓRZ NOWE E-SPRAWOZDANIE
            </Button>
          )}
          <Button onClick={onClose} color="primary">
            ANULUJ
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onUpload: e => dispatch(actions.uploadFile(e)),
    onCloseErrorDialog: () => dispatch(actions.clearError()),
  }
}

export default connect(
  null,
  mapDispatchToProps,
)(ConfirmationDialog)
